import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { SiteHeader } from '@/components/SiteHeader';
import { SiteFooter } from '@/components/SiteFooter';
import { ConcentricRings } from '@/components/Motifs';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <section className="py-24 sm:py-40">
        <div className="max-w-lg mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="flex justify-center mb-8">
              <ConcentricRings size={80} opacity={0.15} />
            </div>
            <p className="font-['Inter'] text-xs font-medium uppercase tracking-[0.2em] text-[hsl(var(--silver))] mb-4">
              404
            </p>
            <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-bold text-[hsl(var(--foreground))] mb-6 leading-[1.1]">
              Beyond the Threshold
            </h1>
            <p className="font-['Inter'] text-base leading-[1.7] text-[hsl(var(--muted-foreground))] mb-10">
              The page you are looking for does not exist, or has been moved to a different location within the observatory.
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link to="/">
                <Button className="bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] font-['Inter'] text-sm font-medium px-8 py-5 rounded-lg hover:brightness-[1.03]">
                  Return Home
                </Button>
              </Link>
              <Link to="/work">
                <Button
                  variant="outline"
                  className="border-[rgba(201,168,76,0.28)] text-[hsl(var(--foreground))] hover:border-[rgba(201,168,76,0.55)] hover:bg-[rgba(27,77,68,0.16)] font-['Inter'] text-sm font-medium px-8 py-5 rounded-lg"
                >
                  Explore the Work
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
